var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"outlined":""},on:{"click":function () { return _vm.action(_vm.result); }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.result)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }